import { FULL_DECK_CORE } from './full-deck';
import {
  createCardSummary,
} from '../internal/library-builders';
import type { CardSummary } from '../internal/types';

export type { CardSummary } from '../internal/types';

export const CARD_SUMMARIES: CardSummary[] = FULL_DECK_CORE.map(createCardSummary);
